var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Header',{attrs:{"details":{
      title: 'Unauthorized',
      actions: false,
    }}}),_c('div',{staticClass:"sub-header"}),_c('div',{staticClass:"client",attrs:{"id":"main-container"}},[_c('p',[_vm._v("Sorry, you are not authorised to view this page with your current user role ( "+_vm._s(_vm.user.role.name)+" ).")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }